import Vue from "vue";
import App from "./App";
import router from "./router";

import editor from "@tinymce/tinymce-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "tinymce/tinymce";

// Theme
import "tinymce/themes/silver/theme";

// Skins
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";

// Plugins
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/paste";
import "tinymce/plugins/autoresize";

import CoreuiVue from "@coreui/vue";
import "./main.css";
import { iconsSet as icons } from "./assets/icons/icons.js";
import { callApi } from "./api/apiUtility";
import { i18n } from "./plugins/i18n";
import VueCookies from "vue-cookies";
import Vuelidate from "vuelidate";
import BootstrapVue from "bootstrap-vue";
import VueMoment from "vue-moment";
import vueNumeralFilterInstaller from "vue-numeral-filter";
import InfiniteScroll from 'vue-infinite-scroll'
import store from "./store";
const moment = require("moment-timezone");
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "babel-polyfill";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { Settings as LuxonSettings } from "luxon";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

//Icon
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faPowerOff,
  faTrashAlt,
  faEye,
  faEyeSlash,
  faSearch,
  faArrowRight,
  faStar,
  faUser,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faFilter,
  faEllipsisV,
  faFileUpload,
  faSortDown,
  faTimesCircle,
  faDownload,
  faPencilAlt,
  faPlus,
  faCheck,
  faTimes,
  faCheckCircle,
  faLock,
  faFileDownload,
  faExclamationCircle,
  faClock,
  faComment,
  faPen,
  faLocationArrow,
  faImage,
  faChevronLeft,
  faQuestionCircle,
  faSearchPlus,
} from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarFar } from "@fortawesome/free-regular-svg-icons";
import { faFacebookF, faLine } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faUserSecret,
  faPowerOff,
  faTrashAlt,
  faEye,
  faEyeSlash,
  faSearch,
  faArrowRight,
  faUser,
  faChevronRight,
  faStarFar,
  faStar,
  faChevronDown,
  faFilter,
  faEllipsisV,
  faFileUpload,
  faSortDown,
  faTimesCircle,
  faDownload,
  faPencilAlt,
  faPlus,
  faCheck,
  faTimes,
  faCheckCircle,
  faChevronUp,
  faLock,
  faFileDownload,
  faExclamationCircle,
  faClock,
  faComment,
  faFacebookF,
  faPen,
  faLocationArrow,
  faImage,
  faChevronLeft,
  faLine,
  faQuestionCircle,
  faSearchPlus,
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

let cookiesDomain = window.location.hostname;
Vue.prototype.$cookiesDomain = cookiesDomain.replace("www", "");
// VueCookies.config('1y', '/', Vue.prototype.$cookiesDomain, '', 'Lax');

Vue.config.performance = true;
Vue.use(InfiniteScroll);
Vue.use(CoreuiVue);
Vue.use(vueNumeralFilterInstaller, { locale: "en-gb" });
Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);

moment.locale(VueCookies.isKey("language") ? VueCookies.get("language") : "en");
import VueSlickCarousel from "vue-slick-carousel";
const Slick = {
  install(Vue, options) {
    Vue.component("slick", VueSlickCarousel);
  },
};

Vue.use(VueMoment, {
  moment,
});
Vue.use(Slick);
Vue.component("datetime", Datetime);
Vue.component("editor", editor);

let globalData = new Vue({
  data: {
    $isLoading: false,
    $screenSize: {
      width: 0,
      height: 0,
    },
    $showAlert: false,
    $hasChange: false,
    $forceRefresh: false,
    $adminSellerId: 0
  },
});

Vue.mixin({
  computed: {
    $isLoading: {
      get: function() {
        return globalData.$data.$isLoading;
      },
      set: function(isLoading) {
        globalData.$data.$isLoading = isLoading;
      },
    },
    $screenSize: {
      get: function() {
        return globalData.$data.$screenSize;
      },
      set: function(screenSize) {
        globalData.$data.$screenSize = screenSize;
      },
    },
    $showAlert: {
      get: function() {
        return globalData.$data.$showAlert;
      },
      set: function(showAlert) {
        globalData.$data.$showAlert = showAlert;
      },
    },
    $hasChange: {
      get: function() {
        return globalData.$data.$hasChange;
      },
      set: function(hasChange) {
        globalData.$data.$hasChange = hasChange;
      },
    },
    $forceRefresh: {
      get: function() {
        return globalData.$data.$forceRefresh;
      },
      set: function(forceRefresh) {
        globalData.$data.$forceRefresh = forceRefresh;
      },
    },
  },
});

Vue.prototype.$language = VueCookies.isKey("language") ? VueCookies.get("language") : "en";
Vue.prototype.$adminSellerId = VueCookies.isKey("adminSellerId") ? VueCookies.get("adminSellerId") : 0;

Vue.prototype.$callApi = callApi;

const MODE = process.env.VUE_APP_MODE || "DEV";
if (MODE === "DEV") {
  Vue.prototype.$sellerSiteUrl = "https://dev-getfin.dosetech.co";
  Vue.prototype.$baseUrl = "https://dev-seller-getfin-api.dosetech.co";
  Vue.prototype.$chatBaseUrl = "https://talkjs-getfin.dosetech.co/api";
  Vue.prototype.$chatBaseUrlSocket =
    "wss://53jlg83cj0.execute-api.ap-southeast-1.amazonaws.com/dev";
}
if (MODE === "PROD") {
  Vue.prototype.$sellerSiteUrl = "https://getfin.me";
  Vue.prototype.$baseUrl = "https://api-partner.getfin.me:331";
  Vue.prototype.$chatBaseUrl = "https://talkjs-api.getfin.me/api";
  Vue.prototype.$chatBaseUrlSocket =
    "wss://53jlg83cj0.execute-api.ap-southeast-1.amazonaws.com/production";
}
if (MODE === "UAT") {
  Vue.prototype.$sellerSiteUrl = "https://uat.getfin.me";
  Vue.prototype.$baseUrl = "https://api-uat-partner.getfin.me:231";
  Vue.prototype.$chatBaseUrl = "https://uat-talkjs-getfin.dosetech.co/api";
  Vue.prototype.$chatBaseUrlSocket =
    "wss://53jlg83cj0.execute-api.ap-southeast-1.amazonaws.com/uat";
}

Vue.prototype.$chatRole = "Partner";
Vue.prototype.$formatDate = "DD MMM YYYY";
Vue.prototype.$formatDateTime = "DD MMM YYYY (HH:mm)";
Vue.prototype.$formatTime = "HH:mm";
Vue.prototype.$headers = {
  "Content-Type": "application/json",
  culture: Vue.prototype.$language,
  sellerId: VueCookies.isKey("adminSellerId") ? VueCookies.get("adminSellerId") : 0,
  Authorization: VueCookies.isKey("seller-token")
    ? `Bearer ${VueCookies.get("seller-token")}`
    : "null",
};
Vue.prototype.$headersZip = {
  "API-KEY": "SK1ADM1FND",
  "Content-Type": "application/zip",
  culture: Vue.prototype.$language,
  Authorization: VueCookies.isKey("seller-token")
    ? `Bearer ${VueCookies.get("seller-token")}`
    : "null",
};
Vue.prototype.$headersChat = {
  "API-KEY": "D!0s6te7H",
  "Content-Type": "application/json",
  culture: Vue.prototype.$language,
  Authorization: VueCookies.isKey("seller-token")
    ? `Bearer ${VueCookies.get("seller-token")}`
    : "null",
};
Vue.prototype.$talkJSAppID = "tdv3kXlp";

LuxonSettings.defaultLocale = Vue.prototype.$language;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!VueCookies.get("seller-token")) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  }
  // else if (to.matched.some(record => record.meta.requiresIsLogin)) {
  //   if (VueCookies.get("seller-token")) {
  //     next({
  //       path: "/",
  //     });
  //   } else {
  //     next();
  //   }
  // } 
  else {
    next();
  }
});

new Vue({
  el: "#app",
  library,
  i18n,
  store,
  router,
  icons,
  template: "<App/>",
  components: {
    App,
  },
});
